import SpaceBetween from "@awsui/components-react/space-between";
import React, { useState } from "react";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Competition from "model/Competition";
import CompetitionsSelect from "components/CompetitionsSelect";
import CompetitionsHeader from "components/CompetitionsHeader";
import { CompetitionState } from "model/CompetitionState";
import { FlashbarProps } from "@awsui/components-react/flashbar/interfaces";
import StageSelect from "components/StageSelect";
import AddPointsButton from "pages/admin/pages/add_points/components/AddPointsButton";
import Box from "@awsui/components-react/box";
import Checkbox from "@awsui/components-react/checkbox";
import Link from "@awsui/components-react/link";
import SubmitFlashbar from "components/SubmitFlashbar";


const AddRidersPage: React.FC = () => {

    const [selectedCompetition, setSelectedCompetition] = useState<Competition>();
    const [buttonEnabled, setButtonEnabled] = useState(true);
    const [stage, setStage] = useState(selectedCompetition?.lastStage || 0);
    const [isTTT, setIsTTT] = useState(false);
    const [useAlternateSource, setUseAlternateSource] = useState(false);
    const [submitMessage, setSubmitMessage] = useState<FlashbarProps.MessageDefinition>();

    return (
        <SpaceBetween size="l">
            <NavigationBar />
            <Container
                header={
                    <Box variant={"span"}>
                        <Header variant="h1">Add points</Header>
                        <Link variant={"info"} href={"/admin"}>Back</Link>
                    </Box>
                }
            >
                <SpaceBetween size={"m"}>
                    <CompetitionsSelect
                        selectedCompetition={selectedCompetition}
                        setSelectedCompetition={setSelectedCompetition}
                        disabledStates={[CompetitionState.NOT_STARTED, CompetitionState.FINISHED]}
                    />
                    {selectedCompetition &&
                        <Container
                            variant={"default"}
                            header={<CompetitionsHeader competition={selectedCompetition} />}
                        >
                            <SpaceBetween size={"m"}>
                                {submitMessage && (
                                    <SubmitFlashbar
                                        submitMessage={submitMessage}
                                        setSubmitMessage={setSubmitMessage}
                                    />
                                )}
                                <StageSelect
                                    setStage={setStage}
                                    length={selectedCompetition.numberOfStages}
                                    lastStage={selectedCompetition.lastStage}
                                />
                                <Checkbox
                                    checked={isTTT}
                                    onChange={({ detail }) => setIsTTT(detail.checked)}
                                >
                                    TTT
                                </Checkbox>
                                <Checkbox
                                    checked={useAlternateSource}
                                    onChange={({ detail }) => setUseAlternateSource(detail.checked)}
                                >
                                    Alternate Source
                                </Checkbox>
                                <AddPointsButton
                                    competition={selectedCompetition}
                                    stage={stage}
                                    isTTT={isTTT}
                                    useAlternateSource={useAlternateSource}
                                    buttonEnabled={buttonEnabled}
                                    setButtonEnabled={setButtonEnabled}
                                    setSubmitMessage={setSubmitMessage}
                                />
                            </SpaceBetween>
                        </Container>
                    }
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    )
};

export default AddRidersPage;
